import { useCallback } from 'react';

import { DashboardEvent } from 'features/dashboard/lib/constants';
import { trackEvent } from 'shared/lib/analytics/trackEvent';

import type { ModalType } from './modalTypes';

export const useTrackedShowModal = (showModal: () => void, modalType: ModalType) => {
  return useCallback(() => {
    showModal();
    trackEvent(DashboardEvent.POPUP_SHOW, {
      type: modalType,
    });
  }, [showModal, modalType]);
};
